import { render, staticRenderFns } from "./carViolationRecordList.vue?vue&type=template&id=58c28d9b&scoped=true"
import script from "./carViolationRecordList.vue?vue&type=script&lang=js"
export * from "./carViolationRecordList.vue?vue&type=script&lang=js"
import style0 from "./carViolationRecordList.vue?vue&type=style&index=0&id=58c28d9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c28d9b",
  null
  
)

export default component.exports